<template>
    <div>
      <b-form class="noPadding">
        <b-form-row>
          <b-col cols="12" md="12">
            <b-form-group class="form-group fontField" label-for="emailAddr">
              <template v-slot:label>
                {{ $t('field.email') }} <span class="text-danger">*</span>
              </template>
              <b-form-input class="form-control form-control-lg" id="emailAddr" name="emailAddr" type="email" required v-model="$v.form.emailAddr.$model" autofocus
                            :state="validateState('emailAddr')" aria-describedby="emailAddr-feedback" :maxLength="config.CUSTOMER_DATA.FIELDS.emailAddr.maxLength"/>
              <b-form-invalid-feedback class="text-left" id="emailAddr-feedback">{{ $t('validation.invalidEmail') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12" md="12">
            <b-button type="submit" @click.stop="onClickCaptcha" :disabled="submitStatus === 'PENDING' || $v.$invalid"
                      class="btn btn-lg btn-block col col-md-auto g-recaptcha w-100 noMargin" variant="primary">{{ $t('button.submit') }}
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import {accountService} from "../../services/api/accountService";

export default {
     data() {
       return {
         form: {
           emailAddr: undefined,
         },
         submitStatus: null,
         responseToken: "",
       }
     },
    computed: {
      config() {
        return window.config;
      },
    },
    validations: {
      form: {
        emailAddr: {
          required,
          email,
        },
      },
    },
    methods: {
      validateState(name) {
        const {$dirty, $error} = this.$v.form[name];
        return $dirty ? !$error : null;
      },
        // eslint-disable-next-line no-undef
        onClickCaptcha(e) {
            console.debug("onClickCaptcha");
            e.preventDefault();
            if(window.config.G_CAPTCHA.enabled == true)
            {
                // eslint-disable-next-line no-undef
                grecaptcha.ready(function() {
                    // eslint-disable-next-line no-undef
                    grecaptcha.execute(window.config.G_CAPTCHA.siteKey, {action: 'submit'}).then(function(token) {
                        this.responseToken = token;
                        this.onSubmit(e);
                    });
                });
            }
            else
            {
                this.onSubmit(e);
            }

        },
       onSubmit: async function (event) {
         event.preventDefault();

         this.$v.$touch();
         if (this.$v.$invalid) {
           this.submitStatus = 'ERROR';
           return;
         } else {
           this.submitStatus = 'OK'
         }

         await accountService.resetPassword(this.form.emailAddr, this.responseToken);

         // Show toast and trigger a callback for navigation
         this.makeToast(
             'success',
             this.$t('notification.forgotPasswordSuccessful'),
             this.$navigateToLogin
         );
       },
  },
}
</script>
